import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const TransferIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "TransferIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}

      <path
        d="M20.4561 6.77437V11.248C20.3959 11.2227 16.8436 9.4465 12.7183 9.4465C8.59293 9.4465 5.03747 11.2227 4.98048 11.248V6.77437C4.98048 5.17552 6.27856 3.87744 7.87741 3.87744H17.5623C19.1612 3.87744 20.4592 5.17235 20.4592 6.77437"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M12.7183 13.0499C8.5961 13.0499 5.04063 11.2733 4.98048 11.248V19.5022C4.98048 19.8442 5.2591 20.1228 5.60103 20.1228H7.34552C7.51016 20.1228 7.66844 20.0563 7.78559 19.9392L8.96019 18.7551C9.07734 18.6379 9.23564 18.5714 9.40028 18.5714H16.0363C16.2009 18.5714 16.3592 18.6379 16.4764 18.7551L17.651 19.9392C17.7681 20.0563 17.9264 20.1228 18.0911 20.1228H19.8355C20.1775 20.1228 20.4561 19.8442 20.4561 19.5022V11.248C20.3959 11.2733 16.8405 13.0499 12.7183 13.0499Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M20.4561 11.248L22.0264 11.2473L22.7197 8.1383H21.143L20.4561 11.248Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M2.71973 8.1383H4.28692L4.98048 11.248L3.4036 11.2473L2.71973 8.1383Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default TransferIcon;
